'use strict';

var TNBuyMoreSaveMore = (function () {

  var _initialised = {};

  // Duration of each card's pie-fill + counter animation
  var FILL_DURATION_MS = 900;
  // Start the next card's animation once the current one is ~85% through
  var OVERLAP_RATIO = 0.85;
  var NEXT_DELAY_MS = FILL_DURATION_MS * OVERLAP_RATIO;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animatePie(card, target) {
    var circle = card.querySelector('.tnbms-badge-circle');
    var percentEl = card.querySelector('.tnbms-badge-percent');
    if (!circle || !target) return;

    var start = performance.now();

    function tick(now) {
      var progress = Math.min((now - start) / FILL_DURATION_MS, 1);
      var eased = easeOutCubic(progress);
      var value = target * eased;
      var angle = value * 3.6; // percent -> degrees

      circle.style.background =
        'conic-gradient(from -90deg, var(--tnbms-badge-fill) ' +
        angle +
        'deg, var(--tnbms-badge-track) ' +
        angle +
        'deg)';

      if (percentEl) {
        percentEl.textContent = Math.round(value) + '%';
      }

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        circle.style.background =
          'conic-gradient(from -90deg, var(--tnbms-badge-fill) ' +
          target * 3.6 +
          'deg, var(--tnbms-badge-track) ' +
          target * 3.6 +
          'deg)';
        if (percentEl) percentEl.textContent = target + '%';
      }
    }

    requestAnimationFrame(tick);
  }

  function revealOneByOne(cards) {
    cards.forEach(function (card, index) {
      setTimeout(function () {
        card.classList.add('is-visible');
        var target = parseFloat(card.getAttribute('data-percent')) || 0;
        animatePie(card, target);
      }, index * NEXT_DELAY_MS);
    });
  }

  function init(sectionId) {

    if (_initialised[sectionId]) return;
    _initialised[sectionId] = true;

    var section = document.getElementById('tnnursery-bms-section-' + sectionId);
    if (!section) return;

    var cards = section.querySelectorAll('.tnbms-card');
    if (!cards.length) return;

    if (!('IntersectionObserver' in window)) {
      revealOneByOne(cards);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        revealOneByOne(cards);
        observer.unobserve(section);
      });
    }, {
      threshold: 0.2,
      rootMargin: '0px 0px -10% 0px'
    });

    observer.observe(section);
  }

  return { init: init };

})();

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[id^="tnnursery-bms-section-"]').forEach(function (el) {
    var sectionId = el.id.replace('tnnursery-bms-section-', '');
    TNBuyMoreSaveMore.init(sectionId);
  });
});